import api from "api";

export function getTaskListData(){
    return api.get(`taskList`)
}

export function getCoachTipList(){
    return api.get(`coachTipList`)
}

export function getDietPlanList(){
    return api.get(`dietPlanList`)
}

export function getHomePageTagLineList(){
    return api.get(`homePageTagLineList`)
}

export function getReorderKitList(){
    return api.get(`reorderKitList`)
}

export function getRootCauseList(){
    return api.get(`rootCauseList`)
}

export function getRootCauseSectionList(){
    return api.get(`rootCauseSectionList`)
}

export function getTrayaDoctorList(){
    return api.get(`trayaDoctorList`)
}

export function getdraftHeaderDataList(){
    return api.get(`draftHeaderDataList`)
}

export function getUserReviewList(){
    return api.get(`userReviewList`)
}

export function getWelcomeVideoList(){
    return api.get(`welcomeVideoList`)
}

export function putTaskList(data, id){
    return api.put(`/taskList/${id}`, data)
}

export function putCoachTipList(data, id){
    return api.put(`/coachTipList/${id}`, data)
}

export function putDietPlanList(data, id){
    return api.put(`/dietPlanList/${id}`, data)
}

export function putHomePageTagLineList(data, id){
    return api.put(`/homePageTagLineList/${id}`, data)
}

export function putRootCauseList(data, id){
    return api.put(`/rootCauseList/${id}`, data)
}

export function putReorderKitList(data, id){
    return api.put(`/reorderKitList/${id}`, data)
}

export function putRootCauseSectionList(data, id){
    return api.put(`/rootCauseSectionList/${id}`, data)
}
export function putTrayaDoctorList(data, id){
    return api.put(`/trayaDoctorList/${id}`, data)
}

export function putDraftHeaderDataList(data, id){
    return api.put(`/draftHeaderDataList/${id}`, data)
}

export function putUserReviewList(data, id){
    return api.put(`/userReviewList/${id}`, data)
}

export function putWelcomeVideoList(data, id){
    return api.put(`/welcomeVideoList/${id}`, data)
}